import { css } from 'linaria';

export const entranceDoorsApartmentSectionTitle = css`
  && {
    position: relative;
    padding-bottom: 140px;

    &::before {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 80px;
      background-color: var(--b2b-light);
      border-radius: var(--rounding-l);
      content: '';
    }

    &::after {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 520px;
      height: 140px;
      background-image: url("https://cdn.lemanapro.ru/lmru/image/upload/q_90,f_auto,c_pad,b_auto/fudzi/elbrus/images/landings/entrance-doors-mf/apartment-section/background-d.png/background-d-2.png");
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
      content: '';
    }

    @media (--only-mobile) {
      padding-bottom: 128px;

      &::after {
        width: 288px;
        height: 104px;
        background-image: url("https://cdn.lemanapro.ru/lmru/image/upload/q_90,f_auto,c_pad,b_auto/fudzi/elbrus/images/landings/entrance-doors-mf/apartment-section/background-m.png/background-m.png");
      }
    }
  }
`;

export const entranceDoorsApartmentSectionCard = css`
  && {
    background-color: var(--b2b-light);

    &:hover {
      filter: brightness(0.9);
    }
  }
`;
